import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation,  Input  } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from 'rxjs';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { ReactivosService } from "../../services/reactivos.service";
import {TranslateService} from '@ngx-translate/core';
import { BroadcastPreview } from '../broadcastpreview.service';

@Component({
    selector     : 'reactivospreview',
    templateUrl  : './reactivospreview.component.html',
    styleUrls    : ['./reactivospreview.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PreviewReactivosComponent {
  idiomasArray: any;
  questions: any = [];
  subscription: Subscription;
  private _unsubscribeAll: Subject<any>;

  constructor(private reactivosService: ReactivosService,
              public snackBar: MatSnackBar,
              private _fuseTranslationLoaderService: FuseTranslationLoaderService,
              private serviceTranslate: TranslateService,
              private broadcast: BroadcastPreview) {

      this._unsubscribeAll = new Subject();

      lang_certificar.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });

      this.subscription = this.broadcast.getEvent().subscribe(product => {
        this.getLanguajesList();
       });


  }



  ngOnInit() {
  this.getLanguajesList();
  }

  public getLanguajesList(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
      this.reactivosService.getLanguajesListNon3(data)
      .subscribe(response => {
        let res = [];
        this.idiomasArray = response['idiomasMostrar'];

      }, error => {
        console.log("error", error);
      })
  }

  public changeIdioma(event){
    //this.nombreIdioma = event.value.nombreIdioma;
    if(event.value.tipoIdioma == 1){
      this.obtienePreviewNativo();
    }else{
      this.obtienePreview(event.value._id);
    }
  }

  public obtienePreview(id){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.reactivosService.getTraducciones(data)
    .subscribe(response => {
      console.log(response);
      if(response['message'] == 'Success'){
        let aux = [];
        response['arrayMostrar'].forEach((idioma) => {
          if(idioma['idiomaId'] == id){
            idioma['reactivos'].forEach((reactivo) => {
              aux.push({
                pregunta: reactivo.preguntaTraduccion
              })
          })
        }

        })
        this.questions = aux;
      }


    }, error => {
      console.log("error", error);
    });
  }

  public obtienePreviewNativo(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.reactivosService.getReactivos(data)
    .subscribe(response => {
      console.log(response);
      if(response['success'] == true){
        if(response['reactivos'].length > 0){
          this.questions = response['reactivos'];
        }

      }

    }, error => {
      console.log("error", error);
    });
  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }


}
